import {z} from 'zod';

export const errorResponseSchema = z.object({
  code: z.string(),
  message: z.string(),
  stack: z.string().nullable().optional(),
  cause: z.unknown().nullable().optional(),
  validationErrors: z
    .array(
      z.object({
        path: z.string(),
        message: z.string(),
      })
    )
    .optional(),
});

export type ErrorResponse = z.infer<typeof errorResponseSchema>;
